import { render, staticRenderFns } from "./FormInputTextWithSuggestions.vue?vue&type=template&id=3776ab00&scoped=true&"
import script from "./FormInputTextWithSuggestions.vue?vue&type=script&lang=ts&"
export * from "./FormInputTextWithSuggestions.vue?vue&type=script&lang=ts&"
import style0 from "./FormInputTextWithSuggestions.vue?vue&type=style&index=0&id=3776ab00&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776ab00",
  null
  
)

export default component.exports